import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import GranjaMap from "./GranjaMap/GranjaMap";
import "./Granja.css";
import { useShoppingContext } from "../context/ShoppingContext";

const Granja = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Obtener el parámetro :id de la URL
  const {
    getGranjaNombre,
    granjaActiva,
    fetchMisAves,
    loadingGranjas,
    hasGalpones,
    hasAves,
    fetchMisGalpones,
    setGranjaActiva,
    fetchMisGranjas,
    isDarkMode,
  } = useShoppingContext();

  useEffect(() => {
    fetchMisGranjas();
    fetchMisAves();
    fetchMisGalpones();
    if (id) {
      setGranjaActiva(parseInt(id));
    }
  }, [id, fetchMisGranjas, fetchMisGalpones, fetchMisAves, setGranjaActiva]);

  if (loadingGranjas || !granjaActiva) {
    return <div className="text-center my-5">Cargando...</div>;
  }

  const needsGalponesSetup = !hasGalpones();
  const needsAvesSetup = !needsGalponesSetup && !hasAves();

  return (
    <div
      className={isDarkMode ? "content-container" : "content-container light"}
    >
      <nav>
        <ul className="granja-header-list">
          <li className="breadcrumb-item">
            <span
              role="button"
              onClick={() => navigate("/mis-granjas")}
              className="text-primary"
            >
              Mis Granjas
            </span>
          </li>{" "}
          <li className="breadcrumb-item active" aria-current="page">
            / {getGranjaNombre(granjaActiva)}
          </li>
        </ul>
      </nav>

      {needsGalponesSetup ? (
        <div className="alert alert-warning">
          <strong>Paso 1:</strong> Necesitas crear un galpón antes de poder
          llevar un control de producción de huevos, mortalidad y alimentación
          de tus aves.
          <button
            className="btn btn-secondary mt-3"
            onClick={() => navigate("/mis-galpones")}
          >
            Crear Galpón
          </button>
        </div>
      ) : needsAvesSetup ? (
        <div className="alert alert-warning">
          <strong>Paso 2:</strong> Ahora debe registrar su primer lote de aves.
          <button
            className="btn btn-primary ml-3"
            onClick={() => navigate("/mis-aves")}
          >
            Agregar Aves
          </button>
        </div>
      ) : (
        <GranjaMap />
      )}
    </div>
  );
};

export default Granja;
